import { useCallback } from 'react';

import { Analytics } from './Analytics';
import type { TrackEvent } from './types';

/**
 * React hook for tracking analytics events.
 * Returns the track function for use in components.
 */
export const useAnalytics = () => {
  const track = useCallback((event: TrackEvent) => {
    Analytics.getInstance().track(event);
  }, []);

  return { track };
};
